export default {
    download_btn_qr_code: "掃這裡",
    download_content_p1: "請用手機掃描開啟",
    download_content_p2: "立即申請借款",
    download_content_p3: "可使用手機自備相機等掃描開啟",
}